<template>
  <div>
    <el-card>
      <div class="forms">
        <el-form :inline="true" :model="form" class="demo-form-inline">
          <el-form-item label="选择区域">
            <el-select v-model="form.pageAreaId" clearable>
              <el-option v-for="(item, index) in selectListData" :label="item.pageArea" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="展示时间">
            <el-date-picker v-model="form.updatedTime" type="date" placeholder="请选择展示时间" clearable value-format="yyyy-MM-dd"> </el-date-picker>
          </el-form-item>
          <el-form-item label="变更人">
            <el-select v-model="form.updatedBy" clearable>
              <el-option v-for="(item, index) in changePersonList" :label="item.nickname" :value="item.nickname" :key="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="searchData" class="btnBackgory">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-popconfirm title="您确定要删除多条数据吗？" @confirm="deleteData">
              <el-button class="white" slot="reference">删除</el-button>
            </el-popconfirm>
          </el-form-item>
          <el-form-item>
            <el-button class="btnBackgory" @click="addHomeData('dialogForm')">新增</el-button>
          </el-form-item>
        </el-form>

        <el-table ref="table" v-loading="loading" :data="tableData" border tooltip-effect="dark" style="width: 100%; margin-top: 20px" @selection-change="handleSelectionChange" max-height="650">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="pageAreaName" label="区域" min-width="140" align="center" />
          <el-table-column prop="imgUrl" label="图片" min-width="80" align="center">
            <template #default="scope">
          <div>
            <img
              style="width: 50px; height: 50px;"
              :src="`${uploadUrl}+${scope.row.imgUrl}`"
              alt=""
            />
          </div>
        </template>
          </el-table-column>
          <el-table-column prop="imgUrl" label="跳转链接" min-width="160" show-overflow-tooltip align="center">
            <template #default="scope">
              <a class="aHref" href="JavaScript:;">{{ scope.row.jumpLink }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="updatedTime" label="变更时间" min-width="120" align="center" />
          <el-table-column prop="updatedBy" label="变更人" min-width="120" align="center" />
          <el-table-column prop="rotationRate" label="轮播频率（秒/毫秒）" min-width="140" align="center" />
          <el-table-column prop="remark" label="备注" show-overflow-tooltip min-width="260" align="center" />
          <el-table-column label="操作" min-width="100" align="center" fixed="right">
            <template #default="scope">
              <div class="operate">
                <div class="btn" @click="edit(scope.row)">编辑</div>
                <el-popconfirm title="您确认要删除该条数据吗？" @confirm="deleteOnly(scope.row)">
                  <div slot="reference" class="btn">删除</div>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageData.page" :page-sizes="[20, 40, 60, 80, 100]" :page-size="pageData.pageSize" layout="total, prev, pager, next,sizes" :total="total"> </el-pagination>
        </div>
      </div>
    </el-card>

    <el-dialog :title="`首页${title}展图`" :visible.sync="dialogVisible" width="810px" @close="cancelBtn('dialogForm')">
      <div class="forms">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="120px" class="demo-dialogForm" label-position="left">
          <el-form-item label="选择区域" prop="pageAreaId">
            <el-select v-model="dialogForm.pageAreaId" clearable>
              <el-option v-for="item in selectListData" :label="item.pageArea" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="轮播频率" prop="rotationRate">
            <div style="display: flex">
              <el-select v-model="dialogForm.rotationRate" clearable placeholder="请选择轮播频率(毫秒)">
                <el-option v-for="item in swiperTimeList" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
              <div style="display: flex; align-items: center; margin-left: 5px" @click="addFaultCause">
                <img style="width: 22px; height: 22px; margin-right: 5px" src="@/assets/gzh/pc/add.png" alt="" />
                <span>新增图片和链接</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item v-for="(item, index) in imageLinkList" :key="index">
            <div style="display: flex">
              <div class="content">
                <el-form :model="explainForm" ref="imageForm" label-width="100px">
                  <div @click="beforeUpload(index)">
                    <el-form-item label="添加图片" style="margin-right: 40px" prop="imgUrl">
                      <el-upload class="avatar-uploader" :action="`${upload}/file/uploadNew`" :show-file-list="false" :on-success="uploadSuccess" list-type="picture-card">
                        <img v-if="imageLinkList[index].invoiceImgId" :src="imageLinkList[index].invoiceImgId" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item label="图片跳转链接" prop="jumpLink">
                      <el-input v-model="imageLinkList[index].jumpLink" style="width: 317px"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                      <el-input type="textarea" v-model="imageLinkList[index].remark"></el-input>
                    </el-form-item>
                  </div>
                </el-form>
              </div>
              <div @click="deleteFaultCause(index)">
                <img style="width: 22px; height: 22px; margin-top: 3px; margin-left: 5px" src="@/assets/gzh/pc/reduce.png" alt="" />
              </div>
            </div>
          </el-form-item>

          <div class="footerBtn">
            <el-button class="dialogWhite" @click="cancelBtn('dialogForm')">取 消</el-button>
            <el-button class="dialogBtnBackgory" @click="submitForm('dialogForm')">确 定</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "pchome",
  data() {
    return {
      form: {
        pageAreaId: "",
        updatedBy: "",
        updatedTime: ""
      },
      upload: "",
      ids: [],
      title: "新增",
      selectListData: [],
      changePersonList: [],
      imageLinkList: [],
      explainForm: {},
      loading: false,
      pageData: {
        page: 1,
        pageSize: 20
      },

      total: 0,
      tableData: [],
      dialogVisible: false,
      dialogForm: {
        pageAreaId: "",
        // jumpLink: "",
        rotationRate: "",
        remark: ""
        // imgUrl: ""
      },
      swiperTimeList: [
        {
          value: "500",
          label: "500"
        },
        {
          value: "1000",
          label: "1000"
        },
        {
          value: "2000",
          label: "2000"
        },
        {
          value: "3000",
          label: "3000"
        },
        {
          value: "4000",
          label: "4000"
        },
        {
          value: "5000",
          label: "5000"
        }
      ],
      dialogRules: {
        pageAreaId: [{ required: true, message: "请选择区域", trigger: "change" }],

        rotationRate: [{ required: true, message: "请选择轮播频率", trigger: "change" }]
      },
      activeIndex: ""
    };
  },
  mounted() {
    this.uploadUrl = apis.uploadUrl;
    this.upload = apis.upload;
    this.getSeleteDataList();
    this.getSearchList({ ...this.pageData });
  },
  methods: {
    // 获取 下拉 数据
    getSeleteDataList() {
      apis.homeSeleteDataList().then(res => {
        if (res.code === 200) {
          this.selectListData = res.data;
        }
      });
      apis.homeChangePersonList().then(res => {
        if (res.code === 200) {
          this.changePersonList = res.data;
        }
      });
    },
    // table 选中
    handleSelectionChange(val) {
      this.ids = val.map(item => item.id);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getSearchList({ ...this.pageData, ...this.form });
    },
    // 新增
    addHomeData(formName) {
      this.getSeleteDataList();
      this.imageLinkList = [];
      const json = {
        invoiceImgId: "",
        jumpLink: "",
        imgUrl: "",
        remark: ""
      };
      this.imageLinkList?.push(json);
      this.title = "新增";
      delete this.dialogForm.id;
      this.dialogForm = {};
      this.$refs[formName]?.resetFields();
      this.dialogVisible = true;
    },
    // 新增跳转链接
    addFaultCause() {
      const json = {
        invoiceImgId: "",
        jumpLink: "",
        imgUrl: "",
        remark: ""
      };
      this.imageLinkList?.push(json);
    },
    beforeUpload(index) {
      this.activeIndex = index;
    },
    uploadSuccess(res) {
      if (res.code === 200) {
        this.imageLinkList[this.activeIndex].invoiceImgId = apis.uploadUrl + res.data.id;
        this.imageLinkList[this.activeIndex].imgUrl = res.data.id;
      }
    },
    // 删除 图片链接
    deleteFaultCause(index) {
      if (this.imageLinkList.length > 1) {
        this.imageLinkList.splice(index, 1);
      }
    },

    // 获取 table 数据
    getSearchList(json) {
      this.loading = true;
      apis.hoemSearchDataList(json).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.total = res.total;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchData() {
      const json = {
        ...this.pageData,
        ...this.form
      };
      this.getSearchList(json);
    },
    // 批量 删除
    deleteData() {
      if (this.ids.length) {
        apis.homeDeleteOnlyData(this.ids).then(res => {
          if (res.code === 200) {
            this.getSearchList(this.pageData);
            this.$message({
              message: "删除成功",
              type: "success"
            });
          }
        });
      }
    },
    // 确认 添加
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        const imageArray = this.imageLinkList.filter(item => {
          if (!item.jumpLink || !item.imgUrl) {
            return item;
          }
        });
        if (imageArray.length > 0) {
          return this.$message({
            message: "请选择图片或输入图片链接",
            type: "warning"
          });
        }
        if (valid) {
          const json = {
            ...this.dialogForm,
            pageShowList: this.imageLinkList.map(item => {
              delete item.invoiceImgId;
              return item;
            })
          };
          const Func = this.dialogForm.id ? apis.homeEdit(json) : apis.homeAdd(json);
          Func.then(res => {
            if (res.code === 200) {
              this.getSearchList({ ...this.pageData });
              this.dialogVisible = false;
              const msg = this.dialogForm.id ? "修改" : "新增";
              this.$message({
                message: `${msg}成功`,
                type: "success"
              });
            }
          });
        }
      });
    },
    //dialog 取消按钮
    cancelBtn(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    // 编辑
    edit(row) {
      this.imageLinkList = [];
      apis.homeEditData(row.id).then(res => {
        if (res.code === 200) {
          this.dialogForm = {
            id: row.id,
            pageAreaId: res.data.pageAreaId,
            rotationRate: res.data.rotationRate
          };
          console.log(apis.uploadUrl + res.data.imgUrl);
          const json = {
            imgUrl: res.data.imgUrl,
            jumpLink: res.data.jumpLink,
            invoiceImgId: apis.uploadUrl + res.data.imgUrl,
            remark: res.data.remark
          };
          this.imageLinkList.push(json);
          this.dialogVisible = true;
          this.title = "编辑";
        }
      });
    },
    // 删除一条
    deleteOnly(row) {
      apis.homeDeleteOnlyData([row.id]).then(res => {
        if (res.code === 200) {
          this.getSearchList({ ...this.pageData });
          this.$message({
            message: "删除成功",
            type: "success"
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-card {
  margin: 20px;
}
::v-deep .el-dialog__title {
  display: flex;
  align-items: center;
  font-size: 29px;
  &::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 29px;
    background-color: #008754;
    margin-right: 10px;
  }
}
.forms {
  .el-button--mini {
    margin-right: 20px;
  }
  .btnBackgory {
    width: 181px;
    height: 54px;
    background-color: #008754;
    color: white;
  }
  .white {
    width: 181px;
    height: 54px;
  }
  .btnBorderColor {
    width: 181px;
    height: 54px;
    color: #008754;
    border-color: #008754;
  }

  ::v-deep .el-form {
    // display: flex;
    // justify-content: space-between;

    .left {
      .el-input--mini .el-input__inner {
        width: 295px;
      }
    }
    .footerBtn {
      text-align: right;
      .dialogWhite {
        width: 145px;
        height: 54px;
      }
      .dialogBtnBackgory {
        width: 145px;
        height: 54px;
        background-color: #008754;
        color: white;
      }
    }
  }
  ::v-deep .el-upload {
    width: 218px;
    height: 124px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  ::v-deep .el-upload:hover {
    border-color: #409eff;
  }
  ::v-deep .el-upload--picture-card {
    line-height: 124px;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 218px;
    height: 124px;
    line-height: 124px;
    text-align: center;
  }
  .avatar {
    width: 218px;
    height: 124px;
    display: block;
  }
}
.pageContainer {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.aHref {
  color: #5e92ff;
}
.operate {
  display: flex;
  justify-content: space-around;
  .btn {
    color: #729fff;
  }
}
::v-deep .el-dialog {
  .el-form {
    .el-input {
      width: 932px;
    }
    .el-textarea__inner {
      width: 575px;
    }
  }
  .content {
    display: flex;
    // justify-content: space-around;
    border: 1px solid #c9c9c9;
    width: 932px;
    padding: 20px;
  }
}
</style>
